import { Grid, TextField, FormHelperText, MenuItem, FormControlLabel, Switch, Tooltip } from '@material-ui/core';
import CustomMaskedInput from 'components/MaskedInput';
import React, { Component } from 'react';
import { EChargeType, EComissionType } from 'v2/interfaces/product';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { run } from 'validations/ruleRunner';

import { Recruitment } from './Recruitment';
import { SelectIntroduction } from './select';
import { SubscriptionPlans } from './SubscriptionPlans';
import Validations from './validations';
import { CustomTooltip } from '../CustomTooltip';
import { FormContent } from '../FormContent';
import styles from '../styles';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  loading: boolean;
  handleChange: any;
  product: IProduct;
  copyFromOriginal?: any;
  modifieds: any;
  editing: any;
  classes: any;
  fade: any;
  onChangeRequiredFields?: any;
  userHasSubscriptionModule: boolean;
  updateProduct: (product: IProduct) => void;
}
interface IStates {
  showErrors: boolean;
  validationErrors: any;
}

class Affiliate extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: run(props.product, Validations),
    };
  }
  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  componentDidUpdate(prevProps: IProps) {
    if (!this.props.loading && this.props.product !== prevProps.product) {
      let { product, onChangeRequiredFields } = this.props;
      let newState = { ...this.state };
      newState.validationErrors = run(product, Validations);
      this.setState(newState);
      if (onChangeRequiredFields) {
        onChangeRequiredFields('affiliateRequiredFields', newState.validationErrors ? Object.keys(newState.validationErrors).length : 0);
      }
    }
  }

  render() {
    const { loading, classes, product, handleChange, modifieds, userHasSubscriptionModule, updateProduct } = this.props;

    if (!product?.allow_affiliation) {
      return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormContent title='' loading={loading}>
              <Grid container spacing={2} alignItems='center'>
                <Grid item xs={12}>
                  <SelectIntroduction onAccept={() => handleChange('allow_affiliation', true)} />
                </Grid>
              </Grid>
            </FormContent>
          </Grid>
        </Grid>
      );
    }

    const commissionTextOnFirstInvoice = () => {
      if (!product.membership_fee && product.trial) {
        return 'Habilitar comissionamento somente na primeira fatura paga.';
      }
      if (product.membership_fee) {
        return 'Habilitar comissionamento somente na taxa de adesão.';
      }
      return 'Habilitar comissionamento somente na primeira fatura';
    };

    const isBetaSubscriptionsFirstInvoice = eduzzAccountsService.verifyUserHasBetaModule('comissao-primeira-fatura');
    const isActiveAffiliateNew = !!modifieds?.allow_affiliation;
    const canEditInfiniteFunnel = isActiveAffiliateNew || !!modifieds?.infinity_funnel || !product.infinity_funnel;
    const isVariation = product.isVariation();
    const isMainWithChildren = product.isMainWithChildren();
    const noEditMessage = 'Só é possível alterar o campo em configurações gerais';
    const activeAfiliateMessage = isActiveAffiliateNew
      ? 'A opção venda por afiliados foi habilitada. Ao salvar o produto não será possível desabilita-la.'
      : 'A opção venda por afiliados foi habilitada. Não é possível desabilitar  vendas por afiliados.';

    const isFree = product.charge_type === EChargeType.FREE;
    const isSubscription = product.charge_type === EChargeType.SUBSCRIPTION;

    const isRecurringComissionPercentage = product.recurring_comission_type === EComissionType.PERCENTAGE;
    const isRecurringComissionValue = product.recurring_comission_type === EComissionType.VALUE;

    const allowRecurringComission = isSubscription && !isFree && !isMainWithChildren;
    const allowRecurringComissionPercentage = allowRecurringComission && isRecurringComissionPercentage;
    const allowRecurringComissionValue = allowRecurringComission && isRecurringComissionValue;
    const isNotComissionOnFirstInvoice = !product.membership_fee || !product.comission_on_first_invoice;
    const isPercentage = product.membership_comission_type === EComissionType.PERCENTAGE;
    const showSubscriptionFirstInvoice = isSubscription && isPercentage && isBetaSubscriptionsFirstInvoice;

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormContent title='Afiliação' loading={loading}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12}>
                <Tooltip title={activeAfiliateMessage}>
                  <FormControlLabel
                    label='Permitir venda por afiliado'
                    control={
                      <Switch
                        color='default'
                        disabled={!isActiveAffiliateNew}
                        checked={product?.allow_affiliation}
                        onChange={(e) => handleChange('allow_affiliation', e.target.checked)}
                      />
                    }
                  />
                </Tooltip>
                <FormHelperText>
                  {activeAfiliateMessage}{' '}
                  <a href='https://ajuda.eduzz.com/hc/pt-br/articles/6037947296411' target='_blank' rel='noopener noreferrer'>
                    Saiba Mais
                  </a>
                </FormHelperText>
              </Grid>
              <Grid item xs={12}>
                <CustomTooltip show={isVariation} message={noEditMessage}>
                  <FormControlLabel
                    label='Visível na vitrine'
                    control={
                      <Switch
                        color='default'
                        disabled={isVariation}
                        checked={product.visible}
                        onChange={(e: any) => handleChange('visible', e.target.checked)}
                      />
                    }
                  />
                </CustomTooltip>
                <FormHelperText>Conteúdo aparecerá na vitrine disponível para afiliação.</FormHelperText>
              </Grid>
              <Grid item xs={12}>
                <CustomTooltip show={isVariation} message={noEditMessage}>
                  <FormControlLabel
                    label='Afiliação automática'
                    control={
                      <Switch
                        disabled={isVariation}
                        color='default'
                        checked={product.auto_affiliation}
                        onChange={(e: any) => handleChange('auto_affiliation', e.target.checked)}
                      />
                    }
                  />
                </CustomTooltip>
                <FormHelperText>Solicitações de afiliação serão aprovadas automaticamente.</FormHelperText>
              </Grid>
              {showSubscriptionFirstInvoice && (
                <Grid item xs={12}>
                  <CustomTooltip show={isVariation} message={noEditMessage}>
                    <FormControlLabel
                      label={!product.membership_fee ? 'Primeira fatura' : 'Taxa de adesão'}
                      control={
                        <Switch
                          color='default'
                          checked={product.comission_on_first_invoice}
                          onChange={(e: any) => handleChange('comission_on_first_invoice', e.target.checked)}
                        />
                      }
                    />
                  </CustomTooltip>
                  <FormHelperText>{commissionTextOnFirstInvoice()}</FormHelperText>
                </Grid>
              )}

              {allowRecurringComission && isNotComissionOnFirstInvoice && !userHasSubscriptionModule && (
                <Grid item xs={12}>
                  <TextField
                    id='recurring_comission_type'
                    label={!product.comission_on_first_invoice ? 'Tipo de comissão recorrente' : 'Tipo de comissão'}
                    select
                    className={classes.input}
                    helperText='Defina o percentual de comissão.'
                    fullWidth
                    error={this.isValid('recurring_comission_type')}
                    value={product.recurring_comission_type}
                    onChange={(e: any) => handleChange('recurring_comission_type', e.target.value)}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={product.recurring_comission_type === EComissionType.PERCENTAGE}
                  >
                    <MenuItem value={EComissionType.PERCENTAGE}>Porcentagem</MenuItem>
                    {product.recurring_comission_type === EComissionType.VALUE && (
                      <MenuItem value={EComissionType.VALUE} disabled>
                        Valor
                      </MenuItem>
                    )}
                  </TextField>
                </Grid>
              )}

              {allowRecurringComissionPercentage && isNotComissionOnFirstInvoice && !userHasSubscriptionModule && (
                <Grid item xs={12}>
                  <CustomMaskedInput
                    fullWidth
                    label={!product.comission_on_first_invoice ? 'Percentual da comissão recorrente' : 'Percentual da comissão'}
                    helperText={this.isValid('recurring_comission_value') ? this.errorFor('recurring_comission_value') : ''}
                    error={this.errorFor('recurring_comission_value')}
                    disableUnderline
                    InputLabelProps={{ shrink: true }}
                    className={classes.input}
                    mask='percent'
                    startAdornment='%'
                    value={product.recurring_comission_value}
                    onChange={(value: any) => handleChange('recurring_comission_value', value)}
                  />
                </Grid>
              )}

              {allowRecurringComissionValue && !product.comission_on_first_invoice && (
                <Grid item xs={12}>
                  <CustomMaskedInput
                    fullWidth
                    label='Valor da comissão recorrente'
                    helperText={this.isValid('recurring_comission_value') ? this.errorFor('recurring_comission_value') : ''}
                    error={this.errorFor('recurring_comission_value')}
                    disableUnderline
                    InputLabelProps={{ shrink: true }}
                    className={classes.input}
                    mask='money'
                    startAdornment='R$'
                    value={product.recurring_comission_value}
                    onChange={(value: any) => handleChange('recurring_comission_value', value)}
                  />
                </Grid>
              )}

              {!isSubscription && !isMainWithChildren && (
                <Grid item xs={12}>
                  <TextField
                    id='comission_type'
                    label={product.charge_type === EChargeType.SUBSCRIPTION ? 'Comissão da Adesão' : 'Tipo de comissão'}
                    select
                    helperText='Comissão com percentual do ganho bruto.'
                    className={classes.input}
                    fullWidth
                    value={product.comission_type}
                    error={this.isValid('comission_type')}
                    onChange={(e: any) => handleChange('comission_type', e.target.value)}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={product.comission_type === EComissionType.PERCENTAGE}
                  >
                    <MenuItem value={EComissionType.PERCENTAGE}>Porcentagem</MenuItem>
                    {product.comission_type === EComissionType.VALUE && product.charge_type !== EChargeType.OTHER && (
                      <MenuItem value={EComissionType.VALUE} disabled>
                        Valor
                      </MenuItem>
                    )}
                  </TextField>
                </Grid>
              )}

              {isSubscription && product.membership_fee && (
                <Grid item xs={12}>
                  <TextField
                    id='membership_comission_type'
                    label='Tipo de comissão da adesão'
                    select
                    className={classes.input}
                    helperText='Defina o percentual de comissão.'
                    fullWidth
                    value={product.membership_comission_type}
                    onChange={(e: any) => handleChange('membership_comission_type', e.target.value)}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={product.membership_comission_type === EComissionType.PERCENTAGE}
                  >
                    <MenuItem value={EComissionType.PERCENTAGE}>Porcentagem</MenuItem>
                    {product.membership_comission_type === EComissionType.VALUE && (
                      <MenuItem value={EComissionType.VALUE} disabled>
                        Valor
                      </MenuItem>
                    )}
                  </TextField>
                </Grid>
              )}

              {!isSubscription && product.comission_type === EComissionType.PERCENTAGE && !isMainWithChildren && (
                <Grid item xs={12}>
                  <CustomMaskedInput
                    fullWidth
                    className={classes.input}
                    helperText={this.isValid('comission_value') ? this.errorFor('comission_value') : ''}
                    label='Percentual da comissão'
                    disableUnderline
                    InputLabelProps={{ shrink: true }}
                    mask='percent'
                    startAdornment='%'
                    value={product.comission_value}
                    onChange={(value: any) => handleChange('comission_value', value)}
                    error={this.isValid('comission_value')}
                  />
                </Grid>
              )}

              {!isSubscription && product.comission_type === EComissionType.VALUE && !isMainWithChildren && (
                <Grid item xs={12}>
                  <CustomMaskedInput
                    fullWidth
                    className={classes.input}
                    helperText={this.isValid('comission_value') ? this.errorFor('comission_value') : ''}
                    label='Valor da comissão'
                    disableUnderline
                    InputLabelProps={{ shrink: true }}
                    mask='money'
                    startAdornment='R$'
                    value={product.comission_value}
                    onChange={(value: any) => handleChange('comission_value', value)}
                    error={this.isValid('comission_value')}
                  />
                </Grid>
              )}

              {product.charge_type === EChargeType.SUBSCRIPTION &&
                product.membership_fee &&
                product.membership_comission_type === EComissionType.PERCENTAGE && (
                  <Grid item xs={12}>
                    <CustomMaskedInput
                      fullWidth
                      label='Percentual da comissão de adesão'
                      helperText={this.isValid('membership_comission_value') ? this.errorFor('membership_comission_value') : ''}
                      error={this.isValid('membership_comission_value')}
                      disableUnderline
                      InputLabelProps={{ shrink: true }}
                      className={classes.input}
                      mask='percent'
                      startAdornment='%'
                      value={product.membership_comission_value}
                      onChange={(value: any) => handleChange('membership_comission_value', value)}
                    />
                  </Grid>
                )}
              {!isMainWithChildren && (
                <Grid item xs={12}>
                  <FormControlLabel
                    label='Funil infinito'
                    control={
                      <Switch
                        color='default'
                        disabled={!canEditInfiniteFunnel}
                        checked={product.infinity_funnel}
                        onChange={(e: any) => handleChange('infinity_funnel', e.target.checked)}
                      />
                    }
                  />
                  <FormHelperText>A opção de funil infinito não pode ser desativada uma vez que for habilitada.</FormHelperText>
                </Grid>
              )}

              {userHasSubscriptionModule && isSubscription && (
                <Grid item xs={12}>
                  <Recruitment
                    loading={loading}
                    product={product}
                    handleChange={handleChange}
                    validInput={this.isValid}
                    errorFor={this.errorFor}
                    classes={classes}
                    isSubscription={isSubscription}
                    userHasSubscriptionModule={userHasSubscriptionModule}
                  />
                </Grid>
              )}

              {product.infinity_funnel && !isMainWithChildren && (
                <Grid item xs={12}>
                  <TextField
                    className={classes.input}
                    id='funnel_commission'
                    select
                    disabled={!canEditInfiniteFunnel}
                    label='Comissão de funil'
                    fullWidth
                    value={product.funnel_commission}
                    onChange={(e: any) => handleChange('funnel_commission', e.target.value)}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                    <MenuItem value={50}>Meia comissão</MenuItem>
                    <MenuItem value={100}>Comissão inteira</MenuItem>
                  </TextField>
                </Grid>
              )}
            </Grid>
          </FormContent>
        </Grid>

        {userHasSubscriptionModule && isSubscription && <SubscriptionPlans loading={loading} product={product} updateProduct={updateProduct} />}

        <Grid item xs={12}>
          <FormContent title='Instruções e Termos' loading={loading}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12}>
                <TextField
                  label='Instruções para afiliados'
                  helperText='Ex: instruções de divulgação para afiliados'
                  id='affiliate_instructions'
                  multiline
                  fullWidth
                  value={product.affiliate_instructions}
                  onChange={(e: any) => handleChange('affiliate_instructions', e.target.value)}
                  className={classes.input}
                  InputProps={{
                    disableUnderline: true,
                    rows: 5,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              {!isVariation && (
                <Grid item xs={12}>
                  <TextField
                    label='Contrato para afiliado'
                    helperText='Ex: termos de aceitação para afiliados'
                    id='affiliation_contract'
                    multiline
                    fullWidth
                    value={product.affiliation_contract}
                    onChange={(e: any) => handleChange('affiliation_contract', e.target.value)}
                    className={classes.input}
                    InputProps={{
                      disableUnderline: true,
                      rows: 5,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </FormContent>
        </Grid>

        {!isFree && !isVariation && !userHasSubscriptionModule && !isSubscription && (
          <Grid item xs={12}>
            <FormContent title='Recrutamento' loading={loading}>
              <Recruitment
                loading={loading}
                product={product}
                handleChange={handleChange}
                validInput={this.isValid}
                errorFor={this.errorFor}
                classes={classes}
                isSubscription={isSubscription}
                userHasSubscriptionModule={userHasSubscriptionModule}
              />
            </FormContent>
          </Grid>
        )}
      </Grid>
    );
  }
}

export default styles(Affiliate);
